<template>
  <main class="text-center ">
    <h5 class="m-3">Import Options</h5>
    <p>Importing to the old inventory. This will TRUNCATE all working tables.</p>
    <button class="btn btn-primary" v-on:click.prevent="start">Start</button>
  </main>
</template>

<script>
export default {
	name: 'ImportOptions',
	methods: {
		start: function() {
			if (!confirm('Please confirm script start.')) return;

			this.$notify({
				group: 'main',
				title: 'Started.',
				text: 'Importing from the old inventory.',
				type: 'success',
			});

			this.$axios.post(`/script`, {script: 'import'})
				.then((response) => {
					// console.log(response.data.data);
				})
				.catch((error) => {
					console.log(error);
					this.$notify({
						group: 'main',
						title: 'Error.',
						text: 'The import has failed.',
						type: 'warn',
					});
				})
				.finally(()=>{
					//
				});
		},
	},
};
</script>
